var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,12 L15,14 L17,14 L17,15 L15,15 L15,17 L14,17 L14,15 L12,15 L12,14 L14,14 L14,12 L15,12 Z M12.5,3 C12.7761424,3 13,3.22385763 13,3.5 L13,4 L14,4 C14.5128358,4 14.9355072,4.38604019 14.9932723,4.88337887 L15,5 L15,11 L14,11 L14,8 L4,8 L4,14 L11,14 L11,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,5 C3,4.44771525 3.44771525,4 4,4 L5,4 L5,3.5 C5,3.22385763 5.22385763,3 5.5,3 C5.77614237,3 6,3.22385763 6,3.5 L6,4 L12,4 L12,3.5 C12,3.22385763 12.2238576,3 12.5,3 Z",
    fill: "currentColor",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAdd);
export default __webpack_public_path__ + "static/media/CalendarAdd.36f7cf63.svg";
export { ForwardRef as ReactComponent };